import CMX from "../../../api";
import * as actions from "../../types";

export const fetchPurchaseOptions = () => (dispatch: any, getState: any) => {
    dispatch({
        type: actions.WALLET_PURCHASE_OPTIONS_FETCH,
    });

    return CMX.get('/me/wallet/purchase/options', {})
        .then((response: any) => {
            dispatch({
                type: actions.WALLET_PURCHASE_OPTIONS_FETCH_SUCCESS,
                payload: response,
            });
        }).catch((error: any) => {
            dispatch({
                type: actions.WALLET_PURCHASE_OPTIONS_FETCH_ERROR,
                payload: error,
            });
        });
};
